import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class Slack extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  async submitSlack() {
    const {
      updateOnboardingStep,
    } = this.props;

    const response = await sendAPIRequest(`/onboarding/submit_slack`, "POST", { });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else {
      throw new Error("invalid status for slack submission: " + response.data.status)
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    return (
      <div className="onboarding-slack-container">
        <div className="onboarding-title">
          Set Up Slack
        </div>
        <div className="onboarding-biglabel onboarding-paypal-subtitle">
          Slack is the primary communications tool for QA World where you can ask questions, receive announcements, and also read and reply to threads that discuss all aspects of working at QA world.
          <br /> <br />
          To set up Slack:
        </div>
        <table className="onboarding-slack-steps">
          <tbody>
            <tr>
              <td>
                <span className="onboarding-slack-list-number">1</span>
              </td>
              <td>
                <p className="onboarding-slack-list-item">Check your email for an invitation</p>
              </td>
            </tr>
            <tr>
              <td>
                <span className="onboarding-slack-list-number">2</span>
              </td>
              <td>
                <p className="onboarding-slack-list-item">Log into <a href="https://slack.com/" target="_blank"  rel="noopener noreferrer">Slack</a> and complete your account setup</p>
              </td>
            </tr>
            <tr>
              <td>
                <span className="onboarding-slack-list-number">3</span>
              </td>
              <td>
                <p className="onboarding-slack-list-item">
                  {
                    currentContractor.transcribe_only ?
                      "When you have set up your Slack account please reach out to the SCCs (anyone with “SCC” in their title) with any questions and feel free to introduce yourself to the channel in #helpdesk" :
                      "When you have set up your Slack account please send Mitch a direct message and she will provide you with training materials for advanced study"
                  }
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="onboarding-biglabel">
          Detailed instructions on account setup are in the <a href="https://docs.google.com/document/d/1a9602ZLbDr-xW8UWPTFwE54gkIHERiX_sLjfHN5C-58/edit?usp=sharing" target="_blank"  rel="noopener noreferrer">Welcome Kit</a>
        </div>
        <div className="onboarding-divider"/>
        <div className="onboarding-submission">
          <Button className="onboarding-submission-button" onClick={() => this.submitSlack()} text="Continue" />
        </div>
      </div>
    );  }

}

export default Slack;
